__turbopack_context__.v({
  "button": "Button-module-scss-module__5L-Eqa__button",
  "content": "Button-module-scss-module__5L-Eqa__content",
  "primary": "Button-module-scss-module__5L-Eqa__primary",
  "secondary": "Button-module-scss-module__5L-Eqa__secondary",
  "tertiary": "Button-module-scss-module__5L-Eqa__tertiary",
  "white": "Button-module-scss-module__5L-Eqa__white",
});
